/*==================================================
検索するボタンのfixed
==================================================*/
if($('.js-search-btn').length) {
  $(window).on('load', function(){
    $('.js-search-btn').removeClass('fixed');
  });
  $(function(){
    var fix    = $('.js-search-btn');
    var fixTop = fix.offset().top;
    var fixTop = fixTop + 90;
    $(window).scroll(function () {
      if($(window).scrollTop() >= fixTop) {
        fix.addClass('fixed');
      } else {
        fix.removeClass('fixed');
      }
    });
  });
};